/* eslint-disable react/jsx-no-target-blank */

import { Fade, Zoom } from "react-awesome-reveal";
import TitleHeader from "../../general/TitleHeader";
import { FaUser } from "react-icons/fa";
import { FaPhone } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { MdDownload } from "react-icons/md";

export default function AboutMe() {
  return (
    <section id="about" className="py-24 mt-16 bg-dark-slate text-custom-white">
      <TitleHeader title={"About Me"} icon={<FaUser />} />

      <div className="container flex items-center justify-around max-xl:flex-col max-xl:gap-8">
        <Zoom>
          <img
            src={`imgs/ali-eui1.jpg`}
            alt={`imgs/ali-eui1.jpg`}
            className={`w-[500px] max-w-full max-md:w-80 rounded-xl shadow-[0_2px_8px_rgba(0,0,0,0.3)] cursor-pointer object-cover`}
          />
        </Zoom>

        <div className="space-y-5 max-w-2xl">
          <Fade cascade damping={0.1}>
            <div className="font-semibold">
              <h3 className="text-2xl">I'm Ali</h3>
              <span className="text-sm">Front End Developer</span>
            </div>

            <p>
              An innovative web developer, passionate about creating exceptional
              digital experiences. I am a dedicated and resourceful web
              developer with expertise in HTML, CSS, JavaScript, Tailwind CSS,
              React, and Next.js. I strive to transform complex challenges into
              elegant and scalable solutions, and I always strive to stay
              abreast of the latest industry trends through continuous learning
              and experimentation. Leveraging my experience and learning
              journey, I look forward to contributing to dynamic projects,
              driving innovation, and making a sustainable impact in a
              collaborative team environment.
              {/* Eager web developer seeking first position, proficient in HTML, CSS, JavaScript,
              Python, Django, Tailwind, React and Next.js Passionate about technology,
              problem-solving, and committed to continuous learning for dynamic project
              contributions and a successful web development career. */}
            </p>

            <div>
              <p className="flex items-center gap-2">
                <span className="text-primary-green flex items-center gap-2">
                  <MdEmail />
                  Email{" "}
                </span>
                : ali.m.elshoraa@gmail.com
              </p>
              <p className="flex items-center gap-2">
                <span className="text-primary-green flex items-center gap-2">
                  <FaPhone />
                  Phone{" "}
                </span>
                : +201550859246
              </p>
            </div>

            <a
              href="https://flowcv.com/resume/wmrcfskcf2"
              target="_blank"
              className="sp-button-components !flex items-center gap-2 font-bold"
            >
              <MdDownload size={25} />
              Resume
            </a>
          </Fade>
        </div>
      </div>
    </section>
  );
}
